// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".controller-header-bottom{height:auto!important}.has-tooltip{background:#b98d36!important}picture.object-cover img{-o-object-fit:cover!important;object-fit:cover!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
